const facebookUrl = 'https://www.facebook.com/groups/themommymingle';

export default function SocialProof() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/283e16bcf3fc9df7cffd75c345f8290d.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/60 to-black/50" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-10 lg:px-20 text-center">
        <p className="text-pink-300 text-sm font-bold tracking-widest uppercase mb-6">Growing Every Day</p>
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-tight mb-6">
          Join 1,000+ local moms<br />across Gwinnett and<br />surrounding areas
        </h2>
        <p className="text-white/70 text-lg max-w-xl mx-auto leading-relaxed mb-10">
          Finding things to do, building friendships, and making life easier — together.
        </p>

        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2.5 px-8 py-4 bg-pink-600 text-white rounded-full text-sm font-bold hover:bg-pink-500 transition-all hover:scale-105 cursor-pointer whitespace-nowrap mb-16"
        >
          <i className="ri-facebook-fill text-base"></i>
          Join The Mommy Mingle — It&apos;s Free
        </a>

        <div className="flex flex-wrap justify-center gap-10 mt-6">
          {[
            { value: '1,000+', label: 'Local Moms' },
            { value: '200+', label: 'Events Per Year' },
            { value: 'Free', label: 'To Join' },
            { value: '5+', label: 'Cities Covered' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-4xl md:text-5xl font-extrabold text-white leading-none">{stat.value}</p>
              <p className="text-white/60 text-sm mt-2 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
